/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Colactions2Inputs */

const zh_admincredit_colactions2 = /** @type {(inputs: Admincredit_Colactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

const en_admincredit_colactions2 = /** @type {(inputs: Admincredit_Colactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const es_admincredit_colactions2 = /** @type {(inputs: Admincredit_Colactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Admincredit_Colactions2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_colactions2 = /** @type {((inputs?: Admincredit_Colactions2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Colactions2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_colactions2(inputs)
	if (locale === "en") return en_admincredit_colactions2(inputs)
	return es_admincredit_colactions2(inputs)
});
export { admincredit_colactions2 as "adminCredit_colActions" }